/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyle3d2Inputs */

const en_aiflowstyle3d2 = /** @type {(inputs: Aiflowstyle3d2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D`)
};

const de_aiflowstyle3d2 = /** @type {(inputs: Aiflowstyle3d2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D`)
};

/**
* | output |
* | --- |
* | "3D" |
*
* @param {Aiflowstyle3d2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyle3d2 = /** @type {((inputs?: Aiflowstyle3d2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyle3d2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyle3d2(inputs)
	return de_aiflowstyle3d2(inputs)
});
export { aiflowstyle3d2 as "aiFlowStyle3d" }